import React, { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import $ from 'jquery'
import { doc, getDoc } from 'firebase/firestore'
import { auth, db } from '../firebase-config'
import { onAuthStateChanged } from 'firebase/auth'
// Components
import PageTransition from '../components/PageTransition'
// CSS
import '../assets/css/course.css'
import '../assets/css/about-course.css'
// Icons
import LiveIcon from '../assets/icons/live.png'
import PeopleIcon from '../assets/icons/people.png'
import ClockIcon from '../assets/icons/clock.png'
import ScheduleIcon from '../assets/icons/schedule.png'

export default function AboutCourse(props) {
  const [courseData, setCourseData] = useState({mentors: [], banner: {type: null}})
  const navigate = useNavigate();
  const [user, setUser] = useState('loading')

  onAuthStateChanged(auth, (user) => {
    if(user){
      setUser(true);
    }
    else{
      setUser(false);
    }
  })

  function scrollTop(){
    window.scrollTo(0, 0)
  }
  
  useEffect(() => {
    getDoc(doc(db, 'Courses', props.courseId)).then((doc) => {
      setCourseData(doc.data().data)
      console.log(doc.data().data.banner.address)
    })

    if(window.location.hash === "#overview"){
      scrollTop()
    }
  }, [])

  function enrollCourse(){
    if(user === true){
      localStorage.setItem('enroll_course_data', JSON.stringify(courseData));
      navigate('/enroll/' + props.courseId);

      return;
    }

    localStorage.setItem('login_redirect_url', '/enroll/' + props.courseId);
    navigate('/login');
  }

  return (
    <div className="about_course_page course_page page_body">
      <PageTransition />
      <div className="container">
        <div className="wrapper">
          <div className="left">
            <div className="course_content select_n">
              {
                courseData.banner.type === null?
                <img src={require('../assets/gifs/media-loading.gif')} alt=""/>
                :
                courseData.banner.type === 'image'?
                <img src={courseData.banner.address} alt="Course Banner" />
                :
                courseData.banner.type === 'video'?
                <video src={courseData.banner.address} controls controlsList="nodownload" autoPlay />
                :
                courseData.banner.type === 'iframe'?
                <iframe width="560" height="315" src={courseData.banner.address} title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                :<></>
              }
            </div>

            <div className='infos'>
              <div className='course_info'>
                <div className='title'><span className='underline'>প্রফেশনাল</span> {courseData.name} <span className='batch'>{courseData.batch != false? 'Batch: '+courseData.batch : ''}</span></div>
              </div>
              <div className='info_cards'>
                {
                  courseData.classType === 'Live'?
                  <div className='card'>
                    <div className='title'><img src={LiveIcon} alt='Live Icon' /> Online Live Course</div>
                  </div>
                  :
                  courseData.classType === 'Recorded'?
                  <></>
                  :
                  <></>
                }
                <div className='card'>
                  <div className='title'><img src={PeopleIcon} alt='People Icon' /> Enrolled</div>
                  <div className='content'>{courseData.enrollCount} People</div>
                </div>
                <div className='card'>
                  <div className='title'><img src={ClockIcon} alt='Clock Icon' /> Time</div>
                  <div className='content'>6 Months</div>
                </div>
                <div className='card'>
                  <div className='title'><img src={ScheduleIcon} alt='Schedule Icon' /> Schedule</div>
                  <div className='content'>{courseData.schedule}</div>
                </div>
              </div>
              <div className="course_price">
                <div className="discount_price">{courseData.discountFee} <span>&#2547;</span></div>
                <div className="main_price">{courseData.fee} <span>&#2547;</span></div>
              </div>
              <div className='actions enroll_action'>
                <button className='btn_primary br_10 w-100 bg-2' onClick={enrollCourse} style={{height: '45px', lineHeight: '47px'}}>Enroll Course</button>
              </div>
            </div>
            
            <section className='mentor_info'>
              <div className='section_title'>Course Mentors</div>

              <div className='section_content'>
                {
                  courseData.mentors.length === 0?
                  <div className='mentor_card'></div>
                  :
                  <></>
                }

                  {
                  courseData.mentors.map((mentor, index) => {
                    return(
                      <div className='mentor_card' key={index}>
                        <div className='image'>
                          <img src={require('../assets/images/mentors/'+mentor.name+'.jpg')} alt='Mentor' />
                        </div>
                        <div className='infos'>
                          <div className='name'>{mentor.name}</div>
                          <span className='bio'>{mentor.bio}</span>
                        </div>
                      </div>
                    )
                  })
                }
              </div>
            </section>
          </div>

          <div className="right">
            <div className='course_info'>
              <div className='title'><span className='underline'>প্রফেশনাল</span> {courseData.name} <span className='batch'>{courseData.batch != false? 'Batch: '+courseData.batch : ''}</span></div>
            </div>
            <div className='info_cards'>
              {
                courseData.classType === 'Live'?
                <div className='card'>
                  <div className='title'><img src={LiveIcon} alt='Live Icon' /> Online Live Course</div>
                </div>
                :
                courseData.classType === 'Recorded'?
                <></>
                :
                <></>
              }
              <div className='card'>
                <div className='title'><img src={PeopleIcon} alt='People Icon' /> Enrolled</div>
                <div className='content'>{courseData.enrollCount} People</div>
              </div>
              <div className='card'>
                <div className='title'><img src={ClockIcon} alt='Clock Icon' /> Time</div>
                <div className='content'>6 Months</div>
              </div>
              <div className='card'>
                <div className='title'><img src={ScheduleIcon} alt='Schedule Icon' /> Schedule</div>
                <div className='content'>{courseData.schedule}</div>
              </div>
            </div>
            <div className="course_price">
              <div className="discount_price">{courseData.discountFee} <span>&#2547;</span></div>
              <div className="main_price">{courseData.fee} <span>&#2547;</span></div>
            </div>
            <div className='actions'>
              <button className='btn_primary btn_hover br_10 w-100 bg-2' onClick={enrollCourse} style={{height: '45px', lineHeight: '47px'}}>Enroll Course</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
